import { parseViewerLocale, type ViewerLocale } from "@garimpa/lib/viewerPreferences";

export function resolveSignInLocale(input: {
  currentLocale: ViewerLocale;
  userLanguage?: unknown;
}): ViewerLocale {
  return parseViewerLocale(input.userLanguage) ?? input.currentLocale;
}
